import React from 'react';
import Card from '../../common/Card';
import Button from '../../common/Button';
import './styles.css';

/**
 * API密鑰卡片組件
 * 用於顯示單個API密鑰的信息和操作按鈕
 * 
 * @param {Object} props - 組件屬性
 * @param {Object} props.apiKey - API密鑰對象
 * @param {Function} props.onDelete - 刪除密鑰的回調函數
 * @param {Function} props.onChangeStatus - 更改密鑰狀態的回調函數
 * @returns {JSX.Element} API密鑰卡片組件
 */
function ApiKeyCard({ apiKey, onDelete, onChangeStatus }) {
    // 格式化日期
    const formatDate = (dateString) => {
        if (!dateString) return '從未使用';
        const date = new Date(dateString);
        return date.toLocaleString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // 判斷密鑰狀態
    const isActive = apiKey.status === 'active' || !apiKey.revoked;
    const statusText = isActive ? '活躍' : '已停用';
    const statusClass = isActive ? 'status-active' : 'status-revoked';

    // 處理狀態變更
    const handleStatusChange = () => {
        // 如果當前是活躍狀態，則停用；如果當前是停用狀態，則啟用
        const newStatus = isActive ? 'revoked' : 'active';
        console.log(`將API密鑰 ${apiKey.id} 的狀態從 ${isActive ? 'active' : 'revoked'} 更改為 ${newStatus}`);
        onChangeStatus(apiKey.id, newStatus);
    };

    return (
        <div className="api-key-card">
            <div className="api-key-header">
                <h3 className="api-key-name">{apiKey.name}</h3>
                <span className={`api-key-status ${statusClass}`}>{statusText}</span>
            </div>

            <div className="api-key-details">
                <div className="api-key-detail">
                    <span className="detail-label">密鑰前綴:</span>
                    <code className="detail-value">{apiKey.prefix}</code>
                </div>
                <div className="api-key-detail">
                    <span className="detail-label">創建時間:</span>
                    <span className="detail-value">{formatDate(apiKey.created_at || apiKey.createdAt)}</span>
                </div>
                <div className="api-key-detail">
                    <span className="detail-label">最後使用:</span>
                    <span className="detail-value">{formatDate(apiKey.last_used_at || apiKey.lastUsed)}</span>
                </div>
            </div>

            <div className="api-key-actions">
                <Button
                    variant={isActive ? "warning" : "success"}
                    size="small"
                    onClick={handleStatusChange}
                >
                    {isActive ? '停用密鑰' : '啟用密鑰'}
                </Button>
                <Button
                    variant="danger"
                    size="small"
                    onClick={() => onDelete(apiKey.id)}
                >
                    刪除密鑰
                </Button>
            </div>
        </div>
    );
}

export default ApiKeyCard; 